import React, { Component } from 'react'
import { Field, reduxForm, reset } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Spinner from '../spinner'
import customInput from './field/customInput'
import { ButtonContained } from '../app-button/button'
import { required } from './validation/validation'

const styles = theme => ({
  form: {
    maxWidth: 320,
    width: '100%',
  },
  close: {
    padding: theme.spacing.unit / 2,
  },
  statusText: {
    marginTop: 22,
    textAlign: 'center',
    fontSize: 16,
    lineHeight: 1.5,
    color: '#000000',
  },
})

const afterSubmit = (result, dispatch) => dispatch(reset('profile'))

class ProfileForm extends Component {
  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    this.setState({ open: false })
  }

  render() {
    const { classes, handleSubmit, isFetching } = this.props

    return (
      <form onSubmit={handleSubmit} className={classes.form}>
        <div className={classes.inputWrapper}>
          <Field
            name="phone"
            component={customInput}
            type="text"
            label="Ваш телефон"
            validate={[required]}
          />
        </div>
        <div className={classes.inputWrapper}>
          <Field
            name="password"
            component={customInput}
            type="password"
            label="Старый пароль"
            validate={[required]}
          />
        </div>
        <div className={classes.inputWrapper}>
          <Field
            name="new_password"
            component={customInput}
            type="password"
            label="Новый пароль"
            validate={[required]}
          />
        </div>
        <ButtonContained
          style={{
            height: 60,
            marginTop: 30,
            fontSize: 16,
            width: '100%',
            fontWeight: 600,
          }}
          type="submit"
          color="secondary"
          text={isFetching ? <Spinner /> : 'Сохранить'}
        />
      </form>
    )
  }
}

ProfileForm = reduxForm({
  form: 'profile',
  onSubmitSuccess: afterSubmit,
})(ProfileForm)

export default withStyles(styles)(ProfileForm)
